import * as buttons from 'smg/buttons';
import * as errors from 'smg/errors';
import { InitGoogleCredentialHandler } from 'smg/googlesignin';
import * as object from 'smg/object';
import { Phone } from 'smg/phone';
import QueryString from 'smg/querystring';
import { PromptLoginCode, RedirectAfterLogin } from '../login';

main();

function main() {
    InitGoogleCredentialHandler();

    const phone = document.querySelector('#phone') as HTMLInputElement;
    setTimeout(() => phone.focus());
    const returnUrl = QueryString().get('return');
    if (returnUrl) {
        const encodedReturnUrl = encodeURIComponent(returnUrl);
        const updateLink = (selector: string) => {
            const link = document.querySelector(selector) as HTMLAnchorElement;
            if (link) {
                const currentHref = link.getAttribute('href') || '';
                link.href = `${currentHref}?return=${encodedReturnUrl}`;
            }
        };
        updateLink('a[href*="login-email"]');
        updateLink('a[href*="join"]');
    }

    const form = document.querySelector('#login-form') as HTMLFormElement;
    const fieldset = form.querySelector('fieldset') as HTMLFieldSetElement;
    const confirm = form.querySelector('[type="submit"]') as HTMLButtonElement;
    const alert = form.querySelector('.alert') as HTMLElement;
    const heading = form.querySelector('h1') as HTMLHeadElement;

    alert.parentElement?.removeChild(alert);
    alert.classList.remove('d-none');

    const showAlert = (type: 'generic' | 'invalid-email' | 'email-unverified') => {
        const a = alert.cloneNode(true) as HTMLElement;
        const msg = a.querySelector(`.${type}`);
        msg?.classList.remove('d-none');

        heading.after(a);
    };

    const hideAlert = () => {
        const a = form.querySelector('.alert');
        a?.parentElement?.removeChild(a);
    };

    const p = new Phone(phone);

    form?.addEventListener('submit', async e => {
        e.preventDefault();

        hideAlert();

        fieldset.setAttribute('disabled', 'disabled');
        buttons.Start(confirm);

        const prompt = await PromptLoginCode({ phone: p });

        void prompt.createCode.finally(() => {
            fieldset.removeAttribute('disabled');
            buttons.Stop(confirm);
        });

        prompt.login.
            then(() => {
                RedirectAfterLogin();
            }).
            catch(err => {
                if (errors.IsAxiosError(err) && errors.IsBindErrors(err.response?.data) && object.IsObject(err['response']) && 'phone' in err.response.data) {
                    errors.ShowError(err);
                } else {
                    showAlert('generic');
                }

                throw err;
            });
    });
}